import dicomParser from "dicom-parser";
import { TAG_DICT } from "./DataDictionary";
import axiosInterceptor from "../../../helpers/Interceptor";
import { APIs } from "../../../constants/Constants";
let ReportText = "";

const formatDate = (date) => {
  if (date) {
    return date.slice(0, 4) + "-" + date.slice(4, 6) + "-" + date.slice(6);
  } else {
    return "-";
  }
};

const formatTime = (time) => {
  if (time) {
    return time.slice(0, 2) + ":" + time.slice(2, 4) + ":" + time.slice(4);
  } else {
    return "";
  }
};

const fetchDescription = (contentSequence, superParent, parent, child) => {
  // .elements['x0040a043'].items[0].dataSet;
  // console.log("NEW LOOP");
  // console.log(contentSequence)
  if (contentSequence.items) {
    for (let i = 0; i < contentSequence.items.length; i++) {
      // console.log(contentSequence.items[i]);
      if (superParent > parent && parent === child) {
        ReportText += "\n";
      }
      const newContentSequence = contentSequence.items[i];
      // console.log(newContentSequence.dataSet.elements)
      for (const key in newContentSequence.dataSet.elements) {
        if (newContentSequence.dataSet.elements[key].vr === "SQ") {
          // console.log(newContentSequence[key]);
          // console.log("")
          if (newContentSequence.dataSet.elements[key].tag === "x0040a730") {
            fetchDescription(
              newContentSequence.dataSet.elements[key],
              0,
              0,
              child + 1
            );
          } else if (
            newContentSequence.dataSet.elements[key].tag === "x0040a043"
          ) {
            fetchDescription(
              newContentSequence.dataSet.elements[key],
              superParent + 1,
              parent,
              child
            );
          } else if (
            newContentSequence.dataSet.elements[key].tag === "x0040a168"
          ) {
            fetchDescription(
              newContentSequence.dataSet.elements[key],
              superParent,
              parent + 1,
              child
            );
          }
        } else if (
          newContentSequence.dataSet.elements[key].vr === "LO" ||
          newContentSequence.dataSet.elements[key].vr === "UT"
        ) {
          // console.log("LO")
          // console.log(newContentSequence.dataSet.elements[key])
          if (superParent > parent) {
            ReportText += "\n" + newContentSequence.dataSet.string(key) + " : ";
            // console.log(newContentSequence.dataSet.string(key) + ":")
          } else {
            ReportText += newContentSequence.dataSet.string(key);
            // console.log(newContentSequence.dataSet.string(key))
          }
        } else if (newContentSequence.dataSet.elements[key].vr === "DA") {
          // console.log("LO")
          // console.log(newContentSequence.dataSet.elements[key])
          if (superParent > parent) {
            ReportText +=
              "\n" + formatDate(newContentSequence.dataSet.string(key)) + " : ";
            // console.log(newContentSequence.dataSet.string(key) + ":")
          } else {
            ReportText += formatDate(newContentSequence.dataSet.string(key));
            // console.log(newContentSequence.dataSet.string(key))
          }
        } else if (newContentSequence.dataSet.elements[key].vr === "TM") {
          // console.log("LO")
          // console.log(newContentSequence.dataSet.elements[key])
          if (superParent > parent) {
            ReportText +=
              "\n" + formatTime(newContentSequence.dataSet.string(key)) + " : ";
            // console.log(newContentSequence.dataSet.string(key) + ":")
          } else {
            ReportText += formatTime(newContentSequence.dataSet.string(key));
            // console.log(newContentSequence.dataSet.string(key))
          }
        }
      }
    }
  }
};

export const generateSRReport = async (path, setSRReport) => {
  const res = await axiosInterceptor.get(path, {
    responseType: "blob",
  });

  ReportText = "";

  var reader = new FileReader();
  reader.onload = function (file) {
    var arrayBuffer = reader.result;
    // Here we have the file data as an ArrayBuffer.  dicomParser requires as input a
    // Uint8Array so we create that here
    var byteArray = new Uint8Array(arrayBuffer);
    try {
      var options = {
        untilTag: "",
        vrCallback(tag) {
          const formatted = `(${tag.substring(1, 5).toUpperCase()},${tag
            .substring(5, 9)
            .toUpperCase()})`;
          return !!TAG_DICT[formatted] ? TAG_DICT[formatted].vr : undefined;
        },
      };

      var dataSet = dicomParser.parseDicom(byteArray, options);

      var keys = [];
      for (var propertyName in dataSet.elements) {
        keys.push(propertyName);
      }
      keys.sort();
      // for (var k = 0; k < keys.length; k++) {
      //   var propertyName = keys[k];
      //   console.log(propertyName);
      //   var element = dataSet.elements[propertyName];
      //   var tag = getTag(element.tag);
      //   console.log(tag);
      //   console.log(element.length);
      // }

      ReportText += "Report Name : \n";
      var reportParent = dataSet.elements["x0040a043"]?.items[0]?.dataSet;
      ReportText += safe(reportParent?.string("x00080104")) + "\n\n";

      ReportText += "Content Date : \n";
      var date = safeDate(dataSet.string("x00080023"));
      var time = safeTime(dataSet.string("x00080033"));
      ReportText += date + " " + time + "\n\n";

      ReportText += "Patient Details : \n";
      var patientName = safe(dataSet.string("x00100010"));
      var patientId = safe(dataSet.string("x00100020"));
      var patientBirthDate = safeDate(dataSet.string("x00100030"));
      var patientSex = safe(dataSet.string("x00100040"));
      ReportText += "Patient Name : " + patientName + "\n";
      ReportText += "Patient ID : " + patientId + "\n";
      ReportText += "Patient BirthDate : " + patientBirthDate + "\n";
      ReportText += "Patient Sex : " + patientSex + "\n\n";

      ReportText += "Study Details : \n";
      var studyDate = safeDate(dataSet.string("x00080020"));
      var studyTime = safeTime(dataSet.string("x00080030"));
      var studyId = safe(dataSet.string("x00200010"));
      var accessionNumber = safe(dataSet.string("x00080050"));
      var referringPhysicianName = safe(dataSet.string("x00080090"));
      ReportText += "Study Date : " + studyDate + " " + studyTime + "\n";
      ReportText += "Study ID : " + studyId + "\n";
      ReportText += "Accession Number : " + accessionNumber + "\n";
      ReportText +=
        "Referring Physician Name : " + referringPhysicianName + "\n\n";

      ReportText += "Report Status : \n";
      var completionFlag = safe(dataSet.string("x0040a491"));
      var verificationFlag = safe(dataSet.string("x0040a493"));
      ReportText += "Completion Flag : " + completionFlag + "\n";
      ReportText += "Verification Flag : " + verificationFlag + "\n\n";

      ReportText += "Report : ";
      fetchDescription(dataSet.elements["x0040a730"], 0, 0, 0);
      //   console.log(ReportText);

      setSRReport(ReportText);
    } catch (error) {
      if (error.response.status === 403)
        window.location.assign(APIs.REDIRECTLOGOUT);
      else return error.response;
    }
  };

  reader.readAsArrayBuffer(res.data);
};

const safe = (v) => (v ? v : "");
const safeDate = (v) => (v ? formatDate(v) : "");
const safeTime = (v) => (v ? formatTime(v) : "");
